import { createStore } from "vuex";
import configure from "./configure";
import user from "./user";
import ticket from "./ticket";

export default createStore({
  modules: {
    configure,
    user,
    ticket,
  },
});
